
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/periodeklassement",
      function () {
        return require("private-next-pages/periodeklassement.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/periodeklassement"])
      });
    }
  